import { Component, Prop, h, State, Event, EventEmitter } from '@stencil/core';
import { ButtonState } from './types';

@Component({
  tag: 'vsr-media-button-v2',
  styleUrl: 'vsr-button.scss',
  shadow: true,
})
export class VsrMediaButton {
  @Prop() variant: 'playing' | 'paused' | 'replay' = 'paused';
  @Prop() state: ButtonState = 'active';

  @State() isFocused: boolean = false;

  @Event() vsrClick: EventEmitter<MouseEvent>;

  private handleClick = (event: MouseEvent) => {
    this.vsrClick.emit(event);
  };

  private getIcon(): string {
    switch (this.variant.toLowerCase()) {
      case 'playing':
        return '⏸';
      case 'paused':
        return '▶';
      case 'replay':
        return '↺';
      default:
        return '▶';
    }
  }

  render() {
    const buttonClass = `media-button ${this.variant.toLowerCase()} ${this.state.toLowerCase()} ${this.isFocused ? 'focused' : ''}`;

    return (
      <button
        class={buttonClass}
        onClick={this.handleClick}
        onFocus={() => (this.isFocused = true)}
        onBlur={() => (this.isFocused = false)}
        aria-label={this.variant}
      >
        {this.getIcon()}
        {this.isFocused && <div class="focus-ring"></div>}
      </button>
    );
  }
}
